import { render, staticRenderFns } from "./MyDataTableNovo.vue?vue&type=template&id=479db200"
import script from "./MyDataTableNovo.vue?vue&type=script&lang=js"
export * from "./MyDataTableNovo.vue?vue&type=script&lang=js"
import style0 from "./MyDataTableNovo.vue?vue&type=style&index=0&id=479db200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports